var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C11.9292 2 12.708 2.63434 12.9326 3.49316C12.3911 3.32136 11.7753 3.4494 11.3457 3.87891L10.5391 4.68359C10.5382 4.6844 10.5379 4.68571 10.5371 4.68652L7.42676 7.79688C7.2076 8.01614 7.05792 8.29563 6.99707 8.59961L6.62695 10.4502C6.56144 10.7779 6.6641 11.1171 6.90039 11.3535C7.13676 11.5899 7.47592 11.6924 7.80371 11.627L9.6543 11.2568C9.95835 11.196 10.2377 11.0464 10.457 10.8271L13 8.28418V12C13 13.1046 12.1046 14 11 14H5C3.89543 14 3 13.1046 3 12V4C3 2.89543 3.89543 2 5 2H11ZM4.5 8.5C4.22386 8.5 4 8.72386 4 9C4 9.27614 4.22386 9.5 4.5 9.5H5.5C5.77614 9.5 6 9.27614 6 9C6 8.72386 5.77614 8.5 5.5 8.5H4.5ZM4.5 6.5C4.22386 6.5 4 6.72386 4 7C4 7.27614 4.22386 7.5 4.5 7.5H6.5C6.77614 7.5 7 7.27614 7 7C7 6.72386 6.77614 6.5 6.5 6.5H4.5ZM4.5 4.5C4.22386 4.5 4 4.72386 4 5C4 5.27614 4.22386 5.5 4.5 5.5H8.5C8.77614 5.5 9 5.27614 9 5C9 4.72386 8.77614 4.5 8.5 4.5H4.5Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6 3H10",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8603 7.01012L11.2441 5.39401L8.13425 8.50391C8.05448 8.58367 8.00011 8.68526 7.97799 8.79588L7.60789 10.6464L9.45839 10.2763C9.569 10.2542 9.67059 10.1998 9.75036 10.12L12.8603 7.01012Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0525 4.58582C12.2757 4.36268 12.6374 4.36268 12.8606 4.58582L13.6686 5.39388C13.8918 5.61702 13.8918 5.97879 13.6686 6.20193L13.2646 6.60596L11.6485 4.98985L12.0525 4.58582Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/Drafts.cf4221d883ad8e62bd01b9d570ffa5a5.svg";
export { ForwardRef as ReactComponent };